export default abstract class Batcher<T, R> {
  static UnprocessedDataError = class extends Error {
    constructor(
      public reason: "cleared",
      message = "Buffer cleared before data was processed.",
    ) {
      super(message);
    }
  };

  protected nextFlush = Promise.withResolvers<Awaited<R>>();
  protected buffer: T[] = [];
  protected abstract readonly fn: (buffer: T[]) => R;

  push(value: T) {
    this.buffer.push(value);

    this.scheduleFlush();
    return this.nextFlush.promise;
  }

  protected abstract scheduleFlush(): void;

  abstract flush(): R | undefined;

  protected call() {
    const buffer = this.buffer;
    this.buffer = [];

    const res = this.fn(buffer);
    this.nextFlush.resolve(res as Awaited<R>);
    this.nextFlush = Promise.withResolvers();

    return res;
  }

  clear() {
    if (this.buffer.length === 0) return;
    this.buffer = [];
    this.nextFlush.reject(new Batcher.UnprocessedDataError("cleared"));
    this.nextFlush = Promise.withResolvers();
  }
}
